/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { XdaStringsService } from '../../../services/xda-strings.service';

@Component({
  selector: 'select-country-component',
  templateUrl: './select-country.component.html',
  styleUrls: ['./select-country.component.less'],
  standalone: false,
})
export class SelectCountryModalComponent {
  title = 'SDE_LOCATION';
  value: string;
  countryList: any[];
  selectedValue: any;

  constructor(
    public activeModal: NgbActiveModal,
    private xdaStringsService: XdaStringsService,
  ) {
    this.title = this.xdaStringsService.strings[this.title];
    this.selectedValue = {};
    this.value = '';
  }

  setValue(option: any) {
    this.selectedValue = option;
    this.value = option.value;
  }
}
